import { Logger } from 'src/utils/Logger';

export const buildCurrencyFormatter = (currency?: string) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency || 'GBP',
  });

export function formatCurrency(
  value: unknown,
  currency: string = 'GBP',
  options?: { fractionDigits?: number },
): string | undefined {
  const castedNumber = Number(value);
  if (isNaN(castedNumber)) {
    Logger.warn('Value is not a number for MONEY', { value });
    return;
  }

  const formatterOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currency,
  };

  if (options?.fractionDigits !== undefined) {
    formatterOptions.minimumFractionDigits = options.fractionDigits;
    formatterOptions.maximumFractionDigits = options.fractionDigits;
  }

  const formatter = new Intl.NumberFormat('en-GB', formatterOptions);
  return formatter.format(castedNumber);
}

export function formatAbbreviatedCurrency(value: number): string {
  if (value >= 1_000_000_000) {
    return `£${(value / 1_000_000_000).toFixed(1)}bn`;
  }
  if (value >= 1_000_000) {
    return `£${(value / 1_000_000).toFixed(1)}m`;
  }
  if (value >= 1_000) {
    return `£${(value / 1_000).toFixed(1)}k`;
  }
  return `£${value.toFixed(0)}`;
}
